// Disabling bz2, xz until tested, esp. across formats

export var baseFormats = ['.arrow', '.csv', '.json',
//'.log',
'.orc', '.parquet',
//'.tsv',
//'.txt',
'.xls', '.xlsx'];

//export const compressFormats = ['.bz2', '.gz', '.xz', '.zip'];
export var compressFormats = ['.gz', '.zip'];
export var compressFormatToFileCompression = {
  //    '.bz2': 'bz2',
  '.gz': 'gzip',
  //    '.xz': 'xz',
  '.zip': 'zip'
};
export var fileCompressionToCompressFormat = {
  //    'bz2': '.bz2',
  'gzip': '.gz',
  //    'xz': '.xz',
  'zip': '.zip'
};